import React, { useState } from "react";
import { FaSearch, FaMapMarkerAlt, FaChevronDown } from "react-icons/fa";
import logo from '../assets/Icons/QuesthireBlack.png'
import { Link, useNavigate } from "react-router-dom";

const MainHome = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
const navigate = useNavigate();
  const handleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="relative shadow-sm py-4 px-10 flex items-center justify-between">        {/* Left: Logo (large, but layout-aware now) */}
        <div className="absolute left-10 top-1/2 -translate-y-1/2">
          <img src={logo} alt="logo" className="h-64 w-64 object-contain" />
        </div>
        <div className="w-64 flex-shrink-0"></div>
        {/* Center: Navigation Buttons */}
        <div className="flex-1 flex justify-center gap-4 text-sm font-semibold">
          {[
            { name: "Job Seekers", items: ["Search Jobs", "Career Advice"] },
            { name: "Small & Medium Business", items: ["Post a Job", "Manage Listings"] },
            { name: "Enterprise Business", items: ["Solutions", "Request a Demo"] },
          ].map((menu) => (
            <div key={menu.name} className="relative group">
              <button
                onClick={() => handleDropdown(menu.name)}
                className="px-6 py-4 rounded hover:bg-gray-200 transition-colors flex items-center gap-2"
              >
                {menu.name}
                <FaChevronDown className="text-xs mt-1" />
              </button>
              {openDropdown === menu.name && (
                <div className="absolute left-0 mt-1 w-48 bg-white border rounded shadow-md z-10">
                  {menu.items.map((item) => (
                    <div key={item} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Right: Action Buttons */}
        <div className="flex-shrink-0 flex items-center gap-2">
          <Link to="/employer-onboarding" className=" text-black px-4 py-2 rounded shadow border font-semibold hover:bg-gray-200 transition duration-200">
            Post a Job
          </Link>
          <button className="px-4 py-2 border border-gray-400 rounded text-black font-semibold hover:bg-gray-200 transition duration-200">
            Log In
          </button>
        </div>
      </header>



      {/* Center Box */}
      <main className="flex flex-col items-center mt-16 px-4">
        <div className=" p-6 rounded border w-full max-w-md shadow-sm text-center">
          <img
            src="https://randomuser.me/api/portraits/men/75.jpg"
            alt="Tom"
            className="h-14 w-14 rounded-full mx-auto mb-4"
          />
          <h2 className="text-xl font-semibold">Welcome!</h2>
          <p className="text-gray-600 mb-4">
            I’m Tom,{" "}
            <span className="relative inline-block">
              <span className="relative z-10">your</span>
              <span className="absolute -bottom-1 left-0 w-full h-2 rounded-full bg-gray-400 opacity-40 z-0"></span>
            </span>{" "}
            career advisor.
          </p>



          <p className="text-sm font-semibold text-gray-700 mb-2">What brings you here today?</p>

          <div className="space-y-2 text-left">
            {[
              "I'm looking for a job right now",
              "I'm looking for a job, but no rush",
              "I'm just browsing",
            ].map((option) => (
              <label
                key={option}
                className="flex items-center border rounded px-3 py-2 cursor-pointer hover:bg-gray-50"
              >
                <input
                  type="radio"
                  name="goal"
                  value={option}
                  checked={selectedOption === option}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  className="mr-3"
                />
                {option}
              </label>
            ))}
          </div>

           <button
      className="mt-4 w-full bg-gray-800 text-white py-2 rounded hover:bg-gray-700"
      onClick={() => navigate("/onboarding")}
    >
      Next
    </button>
        </div>

        {/* Search Bar */}
        <div className="mt-10 w-full max-w-[52rem] flex justify-between items-center  rounded-lg shadow-[0px_0px_5px_rgba(0,0,0,0.25)] pl-4 pr-2 py-2 gap-4">
          <div className="flex items-center flex-1">
            <FaSearch className="text-gray-400 mr-2" />
            <input
              type="text"
              placeholder="Job title, keywords, or company"
              className="w-full outline-none text-sm bg-transparent"
            />
          </div>
          <div className="flex items-center flex-1">
            <FaMapMarkerAlt className="text-gray-400 mr-2" />
            <select className="w-full outline-none text-sm bg-transparent">
              <option>Select</option>
              <option>Remote</option>
              <option>New York</option>
              <option>Toronto</option>
            </select>
          </div>
          <Link to="/search" className="bg-gray-800 text-white px-5 py-2 rounded hover:bg-gray-700">
            Find jobs
          </Link>
        </div>

        {/* Footer Text */}
        <p className="mt-6 text-sm text-center">
          <span className="font-semibold">Upload your resume</span> – it only takes a few seconds<br />
          <span className="font-semibold text-black">Post a job on Questhire</span>
        </p>
      </main>
    </div>
  );
};

export default MainHome;

